import Select from 'react-select';

import type { CustomFilterConfig } from 'hooks/useDirectoryData/types';

import { localize } from '../helpers/localize';

export interface CustomDropdownFilterProps {
  filter: CustomFilterConfig;
  selected: string[];
  locale: string;
  onChange: (selected: string[]) => void;
}

function CustomDropdownFilter({ filter, selected, locale, onChange }: CustomDropdownFilterProps) {
  const options = filter.options.map((option) => {
    return {
      value: option.value,
      label: localize(option.label, locale) ?? option.value,
    };
  });

  if (!filter.multiple) {
    return (
      <Select
        isClearable
        isSearchable={false}
        classNamePrefix="reactSelect"
        placeholder={localize(filter.label, locale)}
        options={options}
        value={
          options.find((option) => {
            return selected.includes(option.value);
          }) ?? null
        }
        onChange={(selectedOption) => {
          onChange(selectedOption ? [selectedOption.value] : []);
        }}
      />
    );
  }

  return (
    <Select
      isMulti
      isClearable
      isSearchable={false}
      closeMenuOnSelect={false}
      classNamePrefix="reactSelect"
      placeholder={localize(filter.label, locale)}
      options={options}
      value={options.filter((option) => {
        return selected.includes(option.value);
      })}
      onChange={(selectedOptions) => {
        onChange(
          (selectedOptions ?? []).map((option) => {
            return option.value;
          }),
        );
      }}
    />
  );
}

export default CustomDropdownFilter;
